<template>
  <!-- <page> -->
  <div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.dateRange }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="reportForm.tranDateFrom"
                            :label="labels.tranDateFrom"
                            :data-vv-as="labels.tranDateFrom"
                            data-vv-name="reportForm.tranDateFrom"
                            :error-messages="errors.collect('reportForm.tranDateFrom')"
                            v-validate="tranDateFromValidation"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="reportForm.tranDateTo"
                            :label="labels.tranDateTo"
                            :data-vv-as="labels.tranDateTo"
                            data-vv-name="reportForm.tranDateTo"
                            :error-messages="errors.collect('reportForm.tranDateTo')"
                            v-validate="tranDateToValidation"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-2"></v-spacer>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.filters }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Occupation Class -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="reportForm.occpCls"
                            :label="labels.occpCls"
                            :error-messages="errors.collect('occpCls')"
                            :data-vv-as="labels.occpCls"
                            data-vv-name="occpCls"
                            append-icon="mdi-magnify"
                            @click:append="multiOccpClsHelplist = true"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-checkbox dense v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="reportForm.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Occupation Class Helplist -->
    <v-dialog v-model="multiOccpClsHelplist" width="900px" persistent>
      <multi-fire-occpn-class-helpList-new
        :occpCls="reportForm.occpCls"
        @close="multiOccpClsHelplist = false"
        @doAssign="doAssign('occpCls', $event)"
      ></multi-fire-occpn-class-helpList-new>
    </v-dialog>
  </div>
  <!-- </page> -->
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { driList } from './index'
import MultiFireOccpnClassHelpListNew from '@/components/core/common/dialog/MultiFireOccpnClassHelpListNew'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Range',
        filters: 'Selection Criteria',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        occpCls: 'Occupation Class',
        export: 'Export To',
        format: 'ASCII TEXT',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        tranDateFrom: null,
        tranDateTo: null,
        occpCls: 'All',
        format: undefined,
        printRptRunTime: true
      },
      loading: false,
      menu: {},
      supportedFormat: [],
      // helplist
      multiOccpClsHelplist: false,
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    tranDateFromValidation() {
      if (this.reportForm.tranDateFrom !== '' && this.reportForm.tranDateFrom !== null && this.reportForm.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.reportForm.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.reportForm.tranDateTo !== '' && this.reportForm.tranDateTo !== null && this.reportForm.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.reportForm.tranDateFrom
      } else {
        return 'required'
      }
    }
  },
  watch: {},
  methods: {
    async doInit() {
      this.reportForm.tranDateTo = new Date()
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initPremAnalysis1
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doAssign(field, Obj) {
      switch (field) {
        case 'occpCls':
          this.reportForm.occpCls = Obj.finalSelectedItems.toString()
          break
      }
    },
    async processExport() {
      const apiURI = this.menu.exportPremAnalysis1OccpCls
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.driList = driList

    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !isAfter(removeTime(value), removeTime(tranFromDate))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !isAfter(removeTime(tranToDate), removeTime(value))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin],
  components: {
    MultiFireOccpnClassHelpListNew
  }
}
</script>

<style>
</style>
